import { createSelector } from 'reselect';
import { careerAndSeasonStatsNavSelector } from '.';

/**
 * @returns {( object ) => object|null} Season.
 */
export const seasonSelector = createSelector(
    careerAndSeasonStatsNavSelector,
    (state) => state.seasons,
    (nav, seasons) => {
        try {
            return seasons[`competition_${nav.competition.id}`][
                `season_${nav.season.id}`
            ];
        } catch (err) {
            return null;
        }
    }
);
